/**
 * Horizontally scrollable state filter component
 * Displays states in 2 rows with horizontal scroll capability
 */

import React from 'react';
import { Button } from './ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const HorizontalStateFilter = ({ states, selectedState, onStateChange, allStatesLabel = 'All States' }) => {
  const scrollRef = React.useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      if (direction === 'left') {
        scrollRef.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }
  };

  return (
    <div className="flex flex-col gap-4 mb-10">
      <div className="flex items-center justify-between gap-2">
        <button
          onClick={() => scroll('left')}
          className="p-2 hover:bg-blue-100 rounded-lg transition-colors flex-shrink-0"
          aria-label="Scroll left"
        >
          <ChevronLeft size={20} className="text-blue-900" />
        </button>

        {/* Horizontally scrollable container */}
        <div
          ref={scrollRef}
          className="flex gap-2 overflow-x-auto scroll-smooth scrollbar-hide flex-1"
          style={{
            scrollBehavior: 'smooth',
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            overflowY: 'hidden',
          }}
        >
          {/* All States Button */}
          <Button
            variant={selectedState === 'All' ? 'default' : 'outline'}
            onClick={() => onStateChange('All')}
            className={`flex-shrink-0 whitespace-nowrap hover:!transform-none ${
              selectedState === 'All' ? 'bg-blue-900 text-white hover:!bg-blue-900 hover:!text-white' : ''
            }`}
          >
            {allStatesLabel}
          </Button>

          {/* State Buttons */}
          {states.map((state) => (
            <Button
              key={state}
              variant={selectedState === state ? 'default' : 'outline'}
              onClick={() => onStateChange(state)}
              className={`flex-shrink-0 whitespace-nowrap hover:!transform-none ${
                selectedState === state ? 'bg-blue-900 text-white hover:!bg-blue-900 hover:!text-white' : ''
              }`}
            >
              {state}
            </Button>
          ))}
        </div>

        <button
          onClick={() => scroll('right')}
          className="p-2 hover:bg-blue-100 rounded-lg transition-colors flex-shrink-0"
          aria-label="Scroll right"
        >
          <ChevronRight size={20} className="text-blue-900" />
        </button>
      </div>
    </div>
  );
};

export default HorizontalStateFilter;
